import React from 'react';

const FrameIoIcon: React.FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.225 8c0 2.194 -0.404 4.303 -1.163 6.227a0.9 0.9 0 0 0 -0.061 0.319c0 0.454 0.355 0.882 0.858 0.882 0.319 0 0.625 -0.196 0.748 -0.502A19.05 19.05 0 0 0 4.904 8c0 -2.452 -0.466 -4.781 -1.299 -6.926a0.81 0.81 0 0 0 -0.748 -0.502C2.355 0.572 2 1 2 1.454c0 0.11 0.025 0.221 0.061 0.319C2.821 3.697 3.225 5.806 3.225 8"
        fill="currentColor"
      />
      <path
        d="M6.582 8c0 1.605 -0.183 3.175 -0.527 4.67 -0.012 0.061 -0.025 0.135 -0.025 0.196 0 0.466 0.368 0.883 0.858 0.883a0.81 0.81 0 0 0 0.784 -0.625 22 22 0 0 0 0.6 -5.125c0 -1.765 -0.208 -3.482 -0.6 -5.124a0.81 0.81 0 0 0 -0.784 -0.625c-0.49 0 -0.858 0.405 -0.858 0.87 0 0.061 0.013 0.135 0.025 0.197A21.1 21.1 0 0 1 6.582 8"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.952 8c0 -0.772 -0.036 -1.52 -0.11 -2.268 -0.049 -0.515 0.343 -0.956 0.845 -0.956 0.429 0 0.785 0.319 0.822 0.735 0.086 0.822 0.122 1.643 0.122 2.489s-0.036 1.667 -0.122 2.489c-0.037 0.416 -0.392 0.735 -0.821 0.735 -0.502 0 -0.895 -0.453 -0.846 -0.956a23.5 23.5 0 0 0 0.11 -2.268m0 0v-0.001"
        fill="currentColor"
      />
      <path
        d="M14.755 8.588c0.16 -0.16 0.245 -0.38 0.245 -0.589 0 -0.221 -0.086 -0.442 -0.245 -0.601l-0.49 -0.478a0.55 0.55 0 0 0 -0.392 -0.159c-0.282 0 -0.564 0.221 -0.564 0.564v1.348c0 0.343 0.281 0.564 0.564 0.564 0.135 0 0.281 -0.049 0.392 -0.16z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FrameIoIcon;
